var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.881,17c-.256,0-.512-.098-.707-.293-.391-.391-.391-1.023,0-1.414l2.536-2.536c.39-.39,.39-1.024,0-1.414l-2.636-2.636c-.391-.391-.391-1.024,0-1.414,.391-.391,1.023-.391,1.414,0l2.636,2.636c.565,.565,.876,1.318,.876,2.121s-.312,1.556-.876,2.121l-2.536,2.536c-.195,.195-.451,.293-.707,.293Zm9.119,2v-6.66C24,5.861,19.096,.454,12.836,.029,9.364-.208,5.961,1.064,3.509,3.521,1.057,5.976-.211,9.378,.03,12.854c.44,6.354,6.052,11.146,13.054,11.146h5.917c2.757,0,5-2.243,5-5ZM12.701,2.024c5.215,.354,9.299,4.885,9.299,10.316v6.66c0,1.654-1.346,3-3,3h-5.917c-6.035,0-10.686-3.905-11.059-9.285-.201-2.899,.855-5.735,2.899-7.782,1.882-1.884,4.435-2.933,7.091-2.933,.228,0,.457,.007,.686,.023Zm-2.875,14.683c.391-.39,.391-1.023,0-1.414l-2.535-2.536c-.39-.39-.39-1.024,0-1.414l2.636-2.636c.391-.391,.391-1.024,0-1.414-.391-.391-1.023-.391-1.414,0l-2.636,2.636c-.565,.565-.876,1.318-.876,2.121s.312,1.556,.876,2.121l2.535,2.536c.195,.195,.451,.293,.707,.293s.512-.098,.707-.293Z",
    fill: "#ffffff",
    "data-original": "#000000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/Code.9984cf11e9393d219d3a02561bd0d904.svg";
export { ForwardRef as ReactComponent };